import { Level2MenuHead, Level2MenuItem } from "@/features";
import { TbSum } from "react-icons/tb";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsEnergyStatement } from "@/utils";

const parentPath = "statement";

export const StatementMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={gettext("Reports")}
      codes={permissionsEnergyStatement}
      feature="common"
      icon={<TbSum size={18} className="mx-3" />}
    >
      <Level2MenuItem
        link={`/${parentPath}/energy`}
        label={gettext("Energy")}
        codes={permissionsEnergyStatement}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/climate`}
        label={gettext("Climate")}
        codes={permissionsEnergyStatement}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/tariff`}
        label={gettext("Tariff")}
        codes={permissionsEnergyStatement}
        feature="common"
      />
      {/* <Level2MenuItem
        link={`/${parentPath}/spot-prices`}
        label={gettext("Spot Prices")}
        codes={permissionsEnergyStatement}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/prices`}
        label={gettext("Prices")}
        codes={permissionsEnergyStatement}
        feature="common"
      /> */}
    </Level2MenuHead>
  );
};
